<div class="container-fluid px-4 mt-2" style="font-size: 0.88rem;">
  
  <!-- HERO PANEL DE BIENVENIDA -->
  <div class="p-4 mb-3 bg-dark text-white rounded shadow-sm d-flex justify-content-between align-items-center" 
       style="background: linear-gradient(135deg, #212529 0%, #343a40 100%);">
    <div>
      <h1 class="h4 fw-bold m-0">¡Bienvenido, {{ usuarioFirmado }}!</h1>
      <p class="text-white-50 m-0 mt-1 small">Ajuste los interruptores de la derecha para personalizar los módulos de su pantalla de inicio.</p>
    </div>
    
    <!-- 🎛️ CAJA DE CONFIGURACIÓN CON BOOTSTRAP SWITCHES INTEGRADA -->
    <div class="bg-white bg-opacity-10 p-2 rounded border border-white border-opacity-10 text-white" style="min-width: 240px; font-size: 0.78rem;">
      <div class="fw-bold mb-2 border-bottom border-white border-opacity-10 pb-1">⚙️ PERSONALIZAR VISTA</div>
      
      <div class="form-check form-switch mb-1">
        <input class="form-check-input" type="checkbox" id="swMetricas" [(ngModel)]="pref.mostrarMetricas" (change)="guardarPreferencias()">
        <label class="form-check-label text-white-50" for="swMetricas">Ver Tarjetas Métricas (KPIs)</label>
      </div>
      <div class="form-check form-switch mb-1">
        <input class="form-check-input" type="checkbox" id="swAvisos" [(ngModel)]="pref.mostrarAvisos" (change)="guardarPreferencias()">
        <label class="form-check-label text-white-50" for="swAvisos">Ver Periódico Mural UDC</label>
      </div>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="swDir" [(ngModel)]="pref.mostrarDirectorio" (change)="guardarPreferencias()">
        <label class="form-check-label text-white-50" for="swDir">Ver Directorio Telefónico</label>
      </div>
    </div>
  </div>


  <!-- ========================================================================= -->
  <!-- 📈 SECCIÓN 1: METRICAS OPERATIVAS Y LÍNEA DE RAMPA (VISIBLE PARA TODOS)   -->
  <!-- ========================================================================= -->
  <div *ngIf="pref.mostrarMetricas" class="animate-fade">
    <div class="fw-bold font-monospace text-secondary text-uppercase mb-2 small" style="letter-spacing: 0.5px;">⚙️ Monitoreo Técnico y Línea de Rampa</div>
    <div class="row g-3 mb-3">
      <div class="col-md-3">
        <div class="card border-0 bg-primary bg-opacity-10 text-primary p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">🚗 Autos en Rampa</div>
          <div class="fs-3 fw-bold mt-1 font-monospace">{{ kpis.vehiculosProceso }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-success bg-opacity-10 text-success p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">📋 Órdenes de Hoy</div>
          <div class="fs-3 fw-bold mt-1 font-monospace">{{ kpis.ordenesHoy }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-info bg-opacity-10 text-info-emphasis p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">⏱️ Eficiencia de la Bahía</div>
          <div class="fs-3 fw-bold mt-1 font-monospace">{{ kpis.eficienciaBahia }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-warning bg-opacity-10 text-warning-emphasis p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">⏳ Estancia Promedio</div>
          <div class="fs-3 fw-bold mt-1 font-monospace">{{ kpis.cycleTimePromedio }}</div>
        </div>
      </div>
    </div>

    <!-- Sub-Fila Técnica de Calidad -->
    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <div class="card border-0 bg-light p-2 px-3 rounded shadow-sm d-flex flex-row justify-content-between align-items-center">
          <span class="text-secondary fw-bold text-uppercase font-monospace small" style="font-size: 0.74rem;">🛠️ Tasa de Retornos / Garantías</span>
          <span class="fw-bold text-danger font-monospace fs-5">{{ kpis.retrabajosTasa }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card border-0 bg-light p-2 px-3 rounded shadow-sm d-flex flex-row justify-content-between align-items-center">
          <span class="text-secondary fw-bold text-uppercase font-monospace small" style="font-size: 0.74rem;">⏱️ Promesa de Entrega Cumplida (On-Time)</span>
          <span class="fw-bold text-success font-monospace fs-5">{{ kpis.onTimeDelivery }}</span>
        </div>
      </div>
    </div>

    <!-- ========================================================================= -->
    <!-- 📊 SECCIÓN 2: CONTROL COMERCIAL Y DE ASEGURADORAS (JEFE Y ADMIN)          -->
    <!-- ========================================================================= -->
    <div class="fw-bold font-monospace text-secondary text-uppercase mb-2 small" style="letter-spacing: 0.5px;">💼 Control Comercial y Gestión de Valuación</div>
    <div class="row g-3 mb-4">
      <div class="col-md-4">
        <div class="card border-0 bg-primary bg-opacity-10 text-primary p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">👥 Clientes Nuevos Mes</div>
          <div class="fs-4 fw-bold mt-1 font-monospace">+{{ kpis.clientesNuevos }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card border-0 bg-success bg-opacity-10 text-success p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">📈 Tasa Conversión Presupuestos</div>
          <div class="fs-4 fw-bold mt-1 font-monospace">{{ kpis.conversionPresupuestos }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card border-0 bg-warning bg-opacity-10 text-warning-emphasis p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">⏱️ Tiempo Valuación Aseguradora</div>
          <div class="fs-4 fw-bold mt-1 font-monospace">{{ kpis.tiempoValuacionAseguradora }}</div>
        </div>
      </div>
    </div>

    <!-- ========================================================================= -->
    <!-- 💰 SECCIÓN 3: INTELIGENCIA FINANCIERA (EXCLUSIVO ROLE_ADMIN / SÚPER ADMIN) -->
    <!-- ========================================================================= -->
    <div class="fw-bold font-monospace text-secondary text-uppercase mb-2 small" style="letter-spacing: 0.5px;">💰 Inteligencia Financiera Corporativa</div>
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <div class="card border-0 bg-dark text-white p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase text-white-50 opacity-75">💼 Total Cotizado Activo</div>
          <div class="fs-4 fw-bold mt-1 font-monospace text-warning">{{ kpis.totalCotizado }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-light p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase text-secondary opacity-75">📊 Ticket Promedio General</div>
          <div class="fs-4 fw-bold mt-1 font-monospace text-dark">{{ kpis.ticketPromedio }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-success bg-opacity-10 text-success p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">📈 Margen Neto Utilidad</div>
          <div class="fs-4 fw-bold mt-1 font-monospace">{{ kpis.margenUtilidadOrden }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-danger bg-opacity-10 text-danger p-3 rounded shadow-sm">
          <div class="small fw-bold text-uppercase opacity-75">🚨 Saldos Vencidos (>30 Días)</div>
          <div class="fs-4 fw-bold mt-1 font-monospace">{{ kpis.antiguedadSaldos30Dias }}</div>
        </div>
      </div>
    </div>
  </div>


  <!-- SECCIÓN 2: MÓDULOS DE SOPORTE E INFORMACIÓN -->
  <div class="row g-4">
    
    <!-- PERIÓDICO MURAL DINÁMICO (UDC) -->
    <div *ngIf="pref.mostrarAvisos" class="col-lg-7 animate-fade">
      <div class="card border-0 shadow-sm h-100 bg-white p-3">
        <div class="border-bottom pb-2 mb-3"><h3 class="h6 m-0 fw-bold text-dark text-uppercase">📢 Anuncios del Personal</h3></div>
        
        <div class="d-flex flex-column gap-3">
          <div *ngFor="let a of avisosDinamicos" class="p-3 rounded border-start border-4 shadow-sm"
               [ngClass]="{
                 'bg-danger-subtle text-danger border-danger': a.tipo === 'urgente',
                 'bg-primary-subtle text-primary border-primary': a.tipo === 'capacitacion',
                 'bg-success-subtle text-success border-success': a.tipo === 'evento',
                 'bg-info-subtle text-info border-info': a.tipo === 'info'
               }">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h4 class="h6 m-0 fw-bold text-uppercase" style="font-size: 0.82rem;">{{ a.titulo }}</h4>
              <span class="badge bg-white text-dark font-monospace border" style="font-size: 0.68rem;">📌 {{ a.fecha }}</span>
            </div>
            <p class="m-0 text-dark opacity-90" style="line-height: 1.4;">{{ a.contenido }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- DIRECTORIO TELEFÓNICO INTERNO -->
    <div *ngIf="pref.mostrarDirectorio" class="col-lg-5 animate-fade">
      <div class="card border-0 shadow-sm h-100 bg-white p-3">
        <div class="border-bottom pb-2 mb-3"><h3 class="h6 m-0 fw-bold text-dark text-uppercase">📞 Extensiones Internas</h3></div>
        <div class="table-responsive">
          <table class="table table-sm table-hover align-middle m-0" style="font-size: 0.82rem;">
            <thead class="table-light text-secondary">
              <tr><th>ÁREA</th><th>RESPONSABLE</th><th class="text-center">EXT.</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of directorio">
                <td class="fw-bold text-dark">{{ d.area }}</td>
                <td class="text-muted">{{ d.responsable }}</td>
                <td class="text-center"><span class="badge bg-dark font-monospace px-2 py-1">{{ d.extension }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>